import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultStandardResource,
    StandardMutationResourceSchema,
    useStandardActions,
} from '../../../../../resource/resources/artifacts/standard/standardResource';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { StandardContent } from './StandardContent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { Text } from '@mantine/core';

export const StandardView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const standardActions = useStandardActions()
    const standardQuery = standardActions.useGetResource(id);
    const updateStandard = standardActions.useUpdateResource();
    const validateStandard = standardActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: StandardMutationResourceSchema,
        defaultValues: defaultStandardResource,
        submitHandler: async (data) => {
            await updateStandard.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: standardQuery.data,
    });

    return (
        <QueryBaseComponent name="Standard" query={standardQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateStandard.data}
                    metaDataInfo={standardQuery.data}
                    resourceType={ResourceType.STANDARD}
                >
                    <Text c="dimmed">Standard</Text>
                </ResourceValidationTitleBar>
                <StandardContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
